export const DESPUES_DEL_EVENTO_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/despuesdelevento.png';
export const DESPUES_DEL_EVENTO_COVER_SRC =
  'https://files.tnonetwork.com/shows/cover/despuesdelevento.jpg';
export const ANGELICA_LUGO_ANCHOR_SRC =
  'https://files.tnonetwork.com/users/profile/angelicalugo2.jpeg';
export const YELITZA_YANEZ_ANCHOR_SRC = '/images/Yelitza Yeye Yanez-SomosPadresInfo.png';
